import { signIn, signOut } from "aws-amplify/auth";

export async function login(email, password) {
  await signIn({ username: email, password }).catch((e) =>
    console.log("Error: ", e)
  );
}

export async function logout() {
  try {
    await signOut();
  } catch (error) {
    console.log("error signing out: ", error);
  }
}

export function getCurrentUser() {
  try {
    const cookies = document.cookie.split(";").map((c) => c.trim());
    const now = Date.now() / 1000;

    // Find access token and id token cookies separately
    const accessTokenCookie = cookies.find(
      (c) =>
        c.startsWith("CognitoIdentityServiceProvider") &&
        c.includes(".accessToken=")
    );
    const idTokenCookie = cookies.find(
      (c) =>
        c.startsWith("CognitoIdentityServiceProvider") &&
        c.includes(".idToken=")
    );

    if (!accessTokenCookie || !idTokenCookie) return false;

    // Decode JWT payloads to check expiration
    const accessToken = accessTokenCookie.split("=").slice(1).join("=");
    const idToken = idTokenCookie.split("=").slice(1).join("=");
    const accessExp = JSON.parse(atob(accessToken.split(".")[1])).exp;
    const idExp = JSON.parse(atob(idToken.split(".")[1])).exp;

    return accessExp > now && idExp > now;
  } catch {
    return false;
  }
}

export function getTokenExpiration() {
  try {
    const cookies = document.cookie.split(";").map((c) => c.trim());
    const accessTokenCookie = cookies.find(
      (c) =>
        c.startsWith("CognitoIdentityServiceProvider") &&
        c.includes(".accessToken=")
    );
    if (!accessTokenCookie) return null;
    const accessToken = accessTokenCookie.split("=").slice(1).join("=");
    const payload = JSON.parse(atob(accessToken.split(".")[1]));
    return payload.exp; // Unix timestamp in seconds
  } catch {
    return null;
  }
}

const services = {
  login,
  logout,
  getCurrentUser,
  getTokenExpiration,
};
export default services;
